(function () {
  'use strict';

  function initFlexstoneFinder() {
    var finder = document.querySelector('[data-fx-finder]');
    if (!finder || finder.dataset.fxFinderReady) return;
    finder.dataset.fxFinderReady = 'true';

    var state = { project: '', priority: '' };
    var projectButtons = Array.prototype.slice.call(finder.querySelectorAll('[data-fx-finder-project]'));
    var secondaryGroups = Array.prototype.slice.call(finder.querySelectorAll('[data-fx-finder-secondary]'));
    var active = finder.querySelector('[data-fx-finder-active]');
    var recommendation = finder.querySelector('[data-fx-finder-recommendation]');
    var commercialCta = finder.querySelector('[data-fx-finder-commercial-cta]');
    var viewAll = finder.querySelector('[data-fx-finder-view-all]');
    var heading = finder.querySelector('[data-fx-finder-results-heading]');
    var count = finder.querySelector('[data-fx-finder-count]');
    var loading = finder.querySelector('[data-fx-finder-loading]');
    var errorMessage = finder.querySelector('[data-fx-finder-error]');
    var empty = finder.querySelector('[data-fx-finder-empty]');
    var results = finder.querySelector('[data-fx-finder-results]');
    var originalResults = results.innerHTML;
    var requestController = null;
    var requestVersion = 0;
    var collectionCache = Object.create(null);
    var projectLabels = { shower: 'Shower or Tub', marble: 'Marble & Stone', feature: 'Feature Wall', wood: 'Wood & Texture', backlit: 'Backlit Feature', commercial: 'Commercial Project' };
    var projectHeadings = { shower: 'All Shower Panels', marble: 'All Marble & Stone', feature: 'Recommended for Feature Walls', wood: 'All Wood & Texture', backlit: 'Backlit Feature Panels', commercial: 'Commercial Project Ideas' };
    var projectViewAllUrls = { shower: '/collections/shower-bathroom', marble: '/collections/all', feature: '/collections/feature-media-wall', wood: '/collections/all', backlit: '/collections/translucent-acrylic-panels', commercial: '/pages/contact' };
    var families = {
      shower: { collections: ['spc-european-line', 'shower-kits-sets', 'book-match-wall-panels'], url: '/collections/shower-bathroom' },
      'shower-spc': { collections: ['spc-european-line'], url: '/collections/spc-european-line' },
      'shower-kits': { collections: ['shower-kits-sets'], url: '/collections/shower-kits-sets' },
      'shower-continuous': { collections: ['book-match-wall-panels'], url: '/collections/book-match-wall-panels' },
      marble: { collections: ['spc-european-line', 'uv-marble-sheets', 'standard-8mm-panels', 'book-match-wall-panels'], url: '/collections/all' },
      'marble-spc': { collections: ['spc-european-line'], url: '/collections/spc-european-line' },
      'marble-uv': { collections: ['uv-marble-sheets'], url: '/collections/uv-marble-sheets' },
      'marble-standard': { collections: ['standard-8mm-panels'], url: '/collections/standard-8mm-panels' },
      'marble-continuous': { collections: ['book-match-wall-panels'], url: '/collections/book-match-wall-panels' },
      'feature-continuous': { collections: ['book-match-wall-panels'], url: '/collections/book-match-wall-panels' },
      'feature-textured': { collections: ['pu-faux-stone'], url: '/collections/pu-faux-stone' },
      'feature-backlit': { collections: ['translucent-acrylic-panels'], url: '/collections/translucent-acrylic-panels' },
      wood: { collections: ['spc-wood-collection', 'vero-wpc-panels', 'fluted-panels', 'acoustic-panels'], url: '/collections/all' },
      'wood-look': { collections: ['spc-wood-collection'], url: '/collections/spc-wood-collection' },
      'wood-fluted': { collections: ['vero-wpc-panels', 'fluted-panels'], url: '/collections/fluted-panels' },
      'wood-acoustic': { collections: ['acoustic-panels'], url: '/collections/acoustic-panels' },
      backlit: { collections: ['translucent-acrylic-panels'], url: '/collections/translucent-acrylic-panels' }
    };
    var filterHeadings = {
      'shower-spc': 'SPC Panels', 'shower-kits': 'Shower Kits', 'shower-continuous': 'Continuous Book-Match Panels',
      'marble-spc': 'SPC Panels', 'marble-uv': 'UV Marble Panels', 'marble-standard': 'Standard 8mm Panels', 'marble-continuous': 'Continuous Book-Match Panels',
      'feature-continuous': 'Continuous Book-Match Panels', 'feature-textured': 'Textured Stone', 'feature-backlit': 'Backlit',
      'wood-look': 'Wood-Look Walls', 'wood-fluted': 'Fluted & Slatted', 'wood-acoustic': 'Acoustic'
    };

    function initScrollHeader() {
      var scrollHeader = finder.querySelector('[data-fx-finder-scroll-header]');
      var intro = finder.querySelector('.fx-finder__intro');
      var sourceFilters = finder.querySelector('.fx-finder__filters');
      var backToTop = finder.querySelector('[data-fx-finder-back-to-top]');
      if (!scrollHeader || !intro || !sourceFilters || !backToTop || !window.matchMedia) return;
      document.body.classList.add('fx-finder-scroll-header-page');
      function syncScrollHeader() {
        var mobile = window.matchMedia('(max-width: 767px)').matches;
        var active = mobile ? sourceFilters.getBoundingClientRect().bottom <= 12 : intro.getBoundingClientRect().bottom <= 118;
        finder.classList.toggle('fx-finder--scroll-header-active', active);
        document.body.classList.toggle('fx-finder-scroll-header-active', active);
        scrollHeader.setAttribute('aria-hidden', active ? 'false' : 'true');
      }
      backToTop.addEventListener('click', function (event) {
        event.preventDefault();
        window.scrollTo(0, 0);
      });
      window.addEventListener('scroll', syncScrollHeader, { passive: true });
      window.addEventListener('resize', syncScrollHeader);
      syncScrollHeader();
    }

    function getKey() { return state.priority ? state.project + '-' + state.priority : state.project; }
    function getCards() { return Array.prototype.slice.call(results.querySelectorAll('[data-fx-finder-card]')); }
    function setLoading(isLoading) { results.setAttribute('aria-busy', isLoading ? 'true' : 'false'); loading.hidden = !isLoading; }
    function clearError() { errorMessage.hidden = true; }
    function syncButtons() {
      projectButtons.forEach(function (button) { button.setAttribute('aria-pressed', button.dataset.fxFinderProject === state.project ? 'true' : 'false'); });
      secondaryGroups.forEach(function (group) {
        var isCurrent = group.dataset.fxFinderSecondary === state.project;
        group.hidden = !isCurrent;
        group.querySelectorAll('[data-fx-finder-priority]').forEach(function (button) { button.setAttribute('aria-pressed', isCurrent && button.dataset.fxFinderPriority === state.priority ? 'true' : 'false'); });
      });
      syncStickyFilters();
    }
    function syncStickyFilters() {
      var stickyFilters = finder.querySelector('[data-fx-finder-scroll-filters]');
      if (!stickyFilters) return;
      var currentSecondary = secondaryGroups.filter(function (group) { return group.dataset.fxFinderSecondary === state.project; })[0];
      stickyFilters.innerHTML = '';
      function appendGroup(label, sourceButtons, type) {
        var group = document.createElement('div');
        var groupLabel = document.createElement('span');
        var options = document.createElement('div');
        group.className = 'fx-finder-scroll-header__filter-group';
        group.setAttribute('role', 'group');
        group.setAttribute('aria-label', label);
        groupLabel.className = 'fx-finder-scroll-header__filter-label';
        groupLabel.textContent = label;
        options.className = 'fx-finder-scroll-header__filter-options';
        sourceButtons.forEach(function (sourceButton) {
          var stickyButton = document.createElement('button');
          var value = type === 'project' ? sourceButton.dataset.fxFinderProject : sourceButton.dataset.fxFinderPriority;
          stickyButton.type = 'button';
          stickyButton.textContent = sourceButton.textContent;
          stickyButton.setAttribute('aria-pressed', sourceButton.getAttribute('aria-pressed'));
          stickyButton.setAttribute('data-fx-finder-scroll-control', type + ':' + value);
          options.appendChild(stickyButton);
        });
        group.appendChild(groupLabel);
        group.appendChild(options);
        stickyFilters.appendChild(group);
      }
      appendGroup('Project', projectButtons, 'project');
      if (currentSecondary) appendGroup('Panel type', Array.prototype.slice.call(currentSecondary.querySelectorAll('[data-fx-finder-priority]')), 'priority');
    }
    function updateActive() {
      if (!state.project) { active.hidden = true; active.innerHTML = ''; return; }
      var html = '<button type="button" data-fx-finder-clear-project>' + projectLabels[state.project] + ' <span aria-hidden="true">×</span><span class="sr-only">, remove</span></button>';
      if (state.priority) html += '<button type="button" data-fx-finder-clear-priority>Clear panel type <span aria-hidden="true">×</span></button>';
      html += '<button type="button" data-fx-finder-clear-all>Clear all</button>';
      active.innerHTML = html;
      active.hidden = false;
    }
    function updateFrame() {
      var family = families[getKey()];
      syncButtons(); updateActive();
      recommendation.hidden = true;
      recommendation.innerHTML = '';
      commercialCta.hidden = state.project !== 'commercial';
      heading.textContent = state.priority ? filterHeadings[getKey()] : (projectHeadings[state.project] || 'Explore Popular Panel Styles');
      viewAll.hidden = !state.project;
      viewAll.href = family ? family.url : projectViewAllUrls[state.project];
    }
    function applyCurated() {
      results.innerHTML = originalResults;
      var visible = 0;
      getCards().forEach(function (card) {
        var projects = (card.dataset.fxFinderProjects || '').split('|');
        var priorities = (card.dataset.fxFinderPriorities || '').split('|');
        var show = !state.project ? card.dataset.fxFinderFeatured === 'yes' : projects.indexOf(state.project) !== -1;
        if (show && state.priority) show = priorities.indexOf(getKey()) !== -1 || (state.project === 'commercial' && priorities.indexOf('commercial-all') !== -1);
        card.hidden = !show;
        if (show) visible += 1;
      });
      count.textContent = visible + (visible === 1 ? ' panel shown' : ' panels shown');
      empty.hidden = visible !== 0;
      setLoading(false);
    }
    function mergeFragments(fragments) {
      var seen = Object.create(null);
      var output = document.createDocumentFragment();
      fragments.forEach(function (html) {
        var template = document.createElement('template');
        template.innerHTML = html;
        Array.prototype.slice.call(template.content.querySelectorAll('[data-fx-finder-dynamic-card]')).forEach(function (card) {
          var id = card.dataset.productId || card.dataset.productHandle;
          if (id && !seen[id]) { seen[id] = true; output.appendChild(card); }
        });
      });
      return output;
    }
    function fetchCollectionPage(handle, page, signal) {
      return fetch('/collections/' + encodeURIComponent(handle) + '?section_id=flexstone-finder-results&page=' + page, { signal: signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Finder collection request failed: ' + handle + ' (' + response.status + ')');
          return response.text();
        });
    }
    function fetchCollection(handle, signal) {
      if (collectionCache[handle]) return Promise.resolve(collectionCache[handle]);
      var pages = [];
      function next(page) {
        return fetchCollectionPage(handle, page, signal).then(function (html) {
          pages.push(html);
          var template = document.createElement('template');
          template.innerHTML = html;
          var fragment = template.content.querySelector('[data-fx-finder-fragment]');
          var nextPage = fragment && fragment.dataset.fxFinderNextPage;
          return nextPage ? next(Number(nextPage)) : pages.join('');
        });
      }
      return next(1).then(function (html) { collectionCache[handle] = html; return html; });
    }
    function loadFamily(family, version) {
      if (requestController) requestController.abort();
      requestController = window.AbortController ? new AbortController() : null;
      var signal = requestController ? requestController.signal : undefined;
      setLoading(true); empty.hidden = true; clearError();
      Promise.all(family.collections.map(function (handle) { return fetchCollection(handle, signal); }))
        .then(function (fragments) {
          if (version !== requestVersion) return;
          results.innerHTML = '';
          results.appendChild(mergeFragments(fragments));
          var visible = results.querySelectorAll('[data-fx-finder-dynamic-card]').length;
          count.textContent = visible + (visible === 1 ? ' panel shown' : ' panels shown');
          empty.hidden = visible !== 0;
          setLoading(false);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (version !== requestVersion) return;
          window.console.error('FlexStone Finder could not load the selected collection.', error);
          setLoading(false);
          errorMessage.hidden = false;
          count.textContent = '';
          results.innerHTML = '';
          empty.hidden = true;
        });
    }
    function apply() {
      requestVersion += 1;
      var family = families[getKey()];
      updateFrame(); clearError();
      if (family) loadFamily(family, requestVersion);
      else { if (requestController) requestController.abort(); applyCurated(); }
    }
    function clearAll() { state.project = ''; state.priority = ''; apply(); }
    projectButtons.forEach(function (button) {
      button.addEventListener('click', function () { var next = button.dataset.fxFinderProject; if (state.project === next) clearAll(); else { state.project = next; state.priority = ''; apply(); } });
    });
    secondaryGroups.forEach(function (group) {
      group.querySelectorAll('[data-fx-finder-priority]').forEach(function (button) {
        button.addEventListener('click', function () { state.priority = state.priority === button.dataset.fxFinderPriority ? '' : button.dataset.fxFinderPriority; apply(); });
      });
    });
    active.addEventListener('click', function (event) {
      if (event.target.closest('[data-fx-finder-clear-project]') || event.target.closest('[data-fx-finder-clear-all]')) clearAll();
      if (event.target.closest('[data-fx-finder-clear-priority]')) { state.priority = ''; apply(); }
    });
    finder.querySelectorAll('[data-fx-finder-clear-all]').forEach(function (button) { button.addEventListener('click', clearAll); });
    finder.querySelector('[data-fx-finder-clear-last]').addEventListener('click', function () { if (state.priority) state.priority = ''; else state.project = ''; apply(); });
    finder.querySelector('[data-fx-finder-scroll-filters]').addEventListener('click', function (event) {
      var stickyButton = event.target.closest('[data-fx-finder-scroll-control]');
      if (!stickyButton) return;
      var parts = stickyButton.dataset.fxFinderScrollControl.split(':');
      var selector = parts[0] === 'project' ? '[data-fx-finder-project="' + parts[1] + '"]' : '[data-fx-finder-priority="' + parts[1] + '"]';
      var sourceButton = finder.querySelector(selector);
      if (sourceButton) sourceButton.click();
    });
    initScrollHeader();
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFlexstoneFinder); else initFlexstoneFinder();
}());
